<template>
	<div class="option" :class="{ hasError: hasValidationError }">
		<component v-if="option.input.type" :is="option.input.type" :option="option" />
	</div>
</template>

<script>
import { mapState } from "vuex";
import InputText from "@/components/inputs/InputText";
import InputTextPrefixes from "@/components/inputs/InputTextPrefixes";
import InputDate from "@/components/inputs/InputDate";
import InputDateLong from "@/components/inputs/InputDateLong";
import InputTextarea from "@/components/inputs/InputTextarea";
import InputSwatch from "@/components/inputs/InputSwatch";
import InputSelect from "@/components/inputs/InputSelect";
import InputImageUpload from "@/components/inputs/InputImageUpload";

export default {
	name: "Option",
	props: ["option"],
	components: { InputText, InputTextPrefixes, InputDate, InputDateLong, InputTextarea, InputSwatch, InputSelect, InputImageUpload },
	computed: {
		...mapState({
			invalidOptions: state => state.configurator.invalidOptions
		}),
		hasValidationError() {
			return this.invalidOptions.indexOf(this.option.id) > -1 ? true : false;
		}
	},
	beforeDestroy() {
		this.$store.dispatch("configurator/deleteSelectedOption", this.option.input.name);
	}
};
</script>

<style lang="scss">
.option {
	text-align: center;

	&.hasError {
		> div input {
			transition: box-shadow 500ms;
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
		}
	}

	> .validation-error {
		background: rgba(255, 0, 0, 0.6);
		padding: 5px 0;
		color: #fff;
		font-weight: bold;
		text-align: center;
	}

	> h3 {
		margin-top: 0;
	}
}

.title {
	&.required {
		&:after {
			color: #f00;
			font-size: 24px;
			content: "*";
			margin-left: 8px;
		}
	}
}
</style>